<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Listas de Precios</h4>
            <div class="small text-muted">Administración general de listas de precios</div>
          </b-col>
        </b-row>
      </b-card>

      <b-row>
        <b-col lg="9">
          <b-row>
            <b-col md="4">                         
              <Widget :configWidget="configWidget" reference="cant_lists" :hasAccess="configWidget.elements.cantLists" />
            </b-col>
            <b-col md="4">                         
              <Widget :configWidget="configWidget" reference="list_listsWithoutCustomers" :hasAccess="configWidget.elements.listListsWithoutCustomers" />
            </b-col>
            <b-col md="4">                         
              <Widget :configWidget="configWidget" reference="list_lists_currency_rate" :hasAccess="configWidget.elements.listListsCurrencyRate" />
            </b-col>            
          </b-row>
        </b-col>  
        <b-col lg="3">                  
          <b-list-group>
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openPriceList()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Lista de Precios</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Administración de las distintas listas de precios.
              </p>
            </b-list-group-item>
          </b-list-group>                           
        
          <b-list-group>
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openCurrency()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Monedas</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Administración de los tipos de monedas y su conversión.
              </p>
            </b-list-group-item>
          </b-list-group>                  
        </b-col>        
      </b-row>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'

  export default {
    components: {
      Widget
    },
    data: () => {
      return {
        access: {
          module_id: Modules.PRECIOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'dashboard',
          elements: {}
        },
        configWidget: {
          module_id: Modules.PRECIOS,
          profile_id: Profiles.PERSONAL,
          elements: {             
            cantLists: true,
            listListsWithoutCustomers: true,
            listListsCurrencyRate: true,
          }
        },
        primaryColor: '',
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */

      /* Configurar permisos de los widgets */      
      this.configWidget.elements.cantLists = Helper.hasAccessWidget(this.configWidget, 'cant_lists')
      this.configWidget.elements.listListsWithoutCustomers = Helper.hasAccessWidget(this.configWidget, 'list_listsWithoutCustomers')
      this.configWidget.elements.listListsCurrencyRate = Helper.hasAccessWidget(this.configWidget, 'list_lists_currency_rate')
      /* Fin configuracion */
    },
    mounted() {
      this.setup()
    }, 
    methods: {
      setup () {        
        if(Session.getSession().settings) {    
          this.primaryColor = Session.getSession().settings.color_primary
                    
          this.createCSS()
        }
      },         
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      }, 
      
      openPriceList() {
        this.$router.push({ name: 'PricesStaffCrudPricesLists' })
      },
        
      openCurrency() {
        this.$router.push({ name: 'PricesStaffCrudCurrency' })
      },     
    }    
   
  }
</script>

<style>

</style>
